var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCellularWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 3C6.703 3 5.647 4.091 5.647 5.432c0 1.111.725 2.05 1.711 2.34v7.565c0 .366.288.663.642.663.354 0 .642-.297.642-.663V7.77c.986-.29 1.71-1.228 1.71-2.339C10.353 4.091 9.298 3 8 3z",
    transform: "translate(-921 -745) translate(97 375) translate(592 254) translate(232 116) translate(4 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.442 2.198c-.273-.264-.717-.264-.99 0C2.28 4.3 2.28 7.7 4.452 9.802c.273.264.717.264.99 0 .273-.265.273-.694 0-.959-1.624-1.571-1.624-4.115 0-5.686.273-.265.273-.694 0-.959zM11.55 2.198c-.274-.264-.718-.264-.992 0-.274.265-.274.694 0 .959 1.622 1.568 1.622 4.118 0 5.686-.274.265-.274.694 0 .959.274.264.718.264.992 0 2.169-2.097 2.169-5.507 0-7.604z",
    transform: "translate(-921 -745) translate(97 375) translate(592 254) translate(232 116) translate(4 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.556 1.148c.278-.262.278-.688 0-.951-.279-.263-.731-.263-1.01 0-3.395 3.2-3.395 8.406 0 11.606.279.263.73.263 1.01 0 .278-.263.278-.689 0-.951-2.839-2.676-2.839-7.028 0-9.704zM13.454.197c-.279-.263-.73-.263-1.01 0-.278.263-.278.689 0 .951 2.839 2.676 2.839 7.028 0 9.704-.278.262-.278.688 0 .951.28.263.731.263 1.01 0 3.395-3.2 3.395-8.406 0-11.606z",
    transform: "translate(-921 -745) translate(97 375) translate(592 254) translate(232 116) translate(4 4)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCellularWhite);
export default __webpack_public_path__ + "static/media/ic-cellular-white.7be006d7e20ebebd7c218492a6fa2f95.svg";
export { ForwardRef as ReactComponent };